<template>
  <v-app-bar
    app
    clipped-left
    flat
    height="72"
    color="white"
    class="header-app-layout"
    v-if="getIsAuthenticated"
    elevation="4"
  >
    <div class="mt-1">
      <slot name="barsBtn"> </slot>
    </div>

    <div class="mt-1">
      <global-logo-display
        :mdWidth="40"
        :lgWidth="50"
        :showVersion="true"
      ></global-logo-display>
    </div>

    <v-spacer></v-spacer>

    <help-menu @openAbout="openAbout"></help-menu>
    <profile-menu
      :expireSoon="expireSoon"
      :description="description"
      @openProfile="openProfile"
      @myCertificate="myCertificate"
      @logoutClicked="logoutClicked"
    ></profile-menu>
    <global-details-popup :vModel="AboutDialog" :fullView="aboutFullView">
      <about-dialog style="z-index: 9999">
        <template v-slot:dialogSize>
          <v-btn icon @click="closeAbout()">
            <v-icon>fa-xmark</v-icon>
          </v-btn>
        </template>
      </about-dialog>
    </global-details-popup>

    <global-details-popup :vModel="ProfileDialog" :fullView="profileFullView">
      <header-profile-dialog
        :details="details"
        @closeProfile="closeProfile"
        style="z-index: 9999"
      >
        <template v-slot:dialogSize>
          <v-btn icon @click="profileFullView = !profileFullView">
            <v-icon v-if="profileFullView">fa-light fa-compress</v-icon>
            <v-icon v-else>fa-light fa-expand</v-icon>
          </v-btn>
          <v-btn icon @click="closeProfile()">
            <v-icon>fa-light fa-xmark</v-icon>
          </v-btn>
        </template>
      </header-profile-dialog>
    </global-details-popup>

    <global-details-popup :vModel="viewItemDialog" :fullView="fullView">
      <certificates-table-view-dialog
        @changeView="changeView"
        @closeDialog="closeDialog"
        @downloadCertificateClicked="downloadCertificateClicked"
        :currentCertificate="currentItem"
        :fullView="fullView"
      />
      </global-details-popup>
    <global-details-popup :vModel="insufficientAccessRightsDialog">
      <insufficient-access-rights-dialog
        style="z-index: 9999">
       <template v-slot:dialogSize>
         <v-btn icon @click="closeInsufficientAccessRights()">
           <v-icon>fa-xmark</v-icon>
         </v-btn>
       </template>
      </insufficient-access-rights-dialog>
    </global-details-popup>
  </v-app-bar>
</template>
<script>
import GlobalDetailsPopup from "@/components/global/global-details-popup.vue";
import GlobalLogoDisplay from "@/components/global/global-logo-display.vue";
import HeaderProfileDialog from "@/components/header-menu/header-profile-dialog.vue";
import AboutDialog from "@/components/header-menu/about-dialog.vue";
import InsufficientAccessRightsDialog from "@/components/header-menu/insufficient-access-rights-dialog.vue";
import HelpMenu from "@/components/header-menu/help-menu.vue";
import ProfileMenu from "@/components/header-menu/profile-menu.vue";
import CertificatesTableViewDialog from "@/components/certificates/certificates-table/view-dialog/certificates-table-view-dialog.vue";
import tableMethods from "@/Mixins/tableMixins";
import pgwyClient from "@/api/pgwyClient";
import { mapActions, mapGetters } from "vuex";
import * as constants from "@/config/constants";

export default {
  mixins: [tableMethods],
  props: ["getIsAuthenticated", "drawer"],
  components: {
    GlobalDetailsPopup,
    HeaderProfileDialog,
    AboutDialog,
    InsufficientAccessRightsDialog,
    GlobalLogoDisplay,
    HelpMenu,
    ProfileMenu,
    CertificatesTableViewDialog,
  },
  data() {
    return {
      details: null,
      description: null,
      officerWarning: false,
      certWarning: false,
      expireDates: null,
      expiringSoon: false,
      ProfileDialog: false,
      AboutDialog: false,
      insufficientAccessRightsDialog: false,
      profileFullView: false,
      aboutFullView: false,
      expireSoon: false,
      viewItemDialog: false,
      currentItem: null,
      fullView: false,
    };
  },
  mounted() {
    if (this.getIsAuthenticated) {
      this.getOfficerDetailsClicked();
    }
  },
  watch: {
    getIsAuthenticated(dd) {
      if (dd === true) {
        this.getOfficerDetailsClicked();
      }
    },
  },
  computed: {
    ...mapGetters(["getOfficerDetails"]),
  },
  methods: {
    ...mapActions(["logout", "checkAuthStatus"]),
    async myCertificate() {
      let res = await pgwyClient
       .getCertificates({ certificateSerialNumber: this.details.certserial });
      if (res && res.data && res.data.certificates.length > 0) {
        this.itemClicked(res.data.certificates[0]);
      } else {
      // Handle the case when the officer does not have access rights to their own cert.
      this.openInsufficientAccessRights();
      }
    },
    getExpirationDate(val) {
      let date;
      let diff;
      if (val === this.details.expires) {
        date = this.details.expires;
      }
      if (val === this.details.certexpires) {
        date = this.details.certexpires;
      }

      let d1 = moment();
      diff = moment(date).diff(d1, "days");

      if (diff < 30) {
        this.expireSoon = true;
      } else {
        this.expireSoon = false;
      }
    },
    openAbout() {
      this.AboutDialog = true;
    },
    closeAbout() {
      this.AboutDialog = false;
    },
    openInsufficientAccessRights() {
      this.insufficientAccessRightsDialog = true;
    },
    closeInsufficientAccessRights() {
      this.insufficientAccessRightsDialog = false;
    },
    openProfile() {
      if (this.getIsAuthenticated) {
        this.getOfficerDetailsClicked();
        this.ProfileDialog = true;
      }
    },
    closeProfile() {
      this.ProfileDialog = false;
    },
    logoutClicked() {
      window.location = constants.WEB_UI_ROOT + constants.LOGOUT_ROUTE_PATH;
    },
    getOfficerDetailsClicked() {
      this.checkAuthStatus().then(() => {
        this.details = this.getOfficerDetails;
        this.description = this.getOfficerDetails.description;
        this.getExpirationDate(
          this.getOfficerDetails.expires || this.getOfficerDetails.certexpires
        );
      });
    },
    async downloadCertificateClicked({ certid, type, extension }) {
      await pgwyClient.downloadCertificates([certid], type, extension);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/style/main.scss";
.m-top {
  margin-top: 16px;
}
.header-app-layout {
  //border-bottom: 1px solid gainsboro !important;
  //height: 4.5rem !important;
  box-shadow: 0 4px 8px 2px rgba(0, 0, 0, 0.12) !important;
  z-index: 10;
}
.header-help-icon {
  font-size: 1.8rem !important;
  margin-top: -5px;
}
.header-divider {
  width: 3rem;
}
.header-user-popup {
  z-index: 999;
}
.header-user-container {
  background-color: #ffffff;
  overflow-y: auto;
}
.header-user-desc {
  border-bottom: 1px solid #eaeaea;
  color: #003088;
  word-wrap: break-word;
}
.header-row-border-menu:hover,
.header-row-border-menu-2:hover {
  background-color: #f3f3f3;
}
.header-row-border-menu {
  padding: 8px;
  border-top: 1px solid gainsboro;
}
.header-row-border-menu-2 {
  padding: 4px 12px 4px 12px;
}
.header-profile-btn {
  background-color: #c5c5c5 !important;
  margin-top: 5px;
  margin-right: 12px;
}
.header-profile-btn::before {
  background-color: transparent !important;
}
.header-profile-btn i:hover {
  transform: scale(1.3);
}
.mini-menu-item:hover {
  background-color: #ececec;
  cursor: pointer;
}
</style>
